import Swal from 'sweetalert2';
import {getAllUsers} from '../../services/UserServices'

export function checkForDuplicateUsers(userName, userEmail, cookies, existingId) {
    
    
    let nameCheck = new Promise((resolve, reject) => {
      getAllUsers(cookies)
      .then((data) => {

        let isUserExists = false; 
        data.user_list.forEach(user => {
          
          if(
            (user.username.toUpperCase() === userName.trim().toUpperCase()
            || user.email.toUpperCase() === userEmail.trim().toUpperCase)
            && parseInt(existingId) !== user.id){   
            
            console.log(`User exists with the name/email - ${userName}/${userEmail}`) 
            isUserExists = true;
          }
        });
        
        resolve(isUserExists);
      });  
    });

    return nameCheck;
  }

  export function isUserNameValid(userName) {

    let isValid = true;

    if(!/^[a-zA-Z0-9_.+\@]+$/.test(userName.trim())) {
      isValid = false;
    }
    return isValid;
  }

  export const PASSWORD_MAX_LENGTH = 32;

  export function isPasswordValid(value) {
    const password = (value || '').trim();
    if (!password) {
      return 'Password must not be empty.';
    }

    const capsCount = (password.match(/[A-Z]/g) || []).length;
    const smallCount = (password.match(/[a-z]/g) || []).length;
    const numberCount = (password.match(/[0-9]/g) || []).length;
    const symbolCount = (password.match(/[@$!%*?&]/g) || []).length;

    if (password.length < 4) {
      return 'Password must be minimum 4 characters include one UPPERCASE, lowercase, number and special character: @$! % * ? &';
    }
    if (capsCount < 1) {
      return 'Must contain one UPPERCASE letter';
    }
    if (smallCount < 1) {
      return 'Must contain one lowercase letter';
    }
    if (numberCount < 1) {
      return 'Must contain one number';
    }
    if (symbolCount < 1) {
      return 'Must contain one special character: @$! % * ? &';
    }
    if (password.length > PASSWORD_MAX_LENGTH) {
      return `Password must be at most ${PASSWORD_MAX_LENGTH} characters.`;
    }

    return '';
  }

  export function validateUserCreateForm(inputs, selectedCategory, selectedPlant) {
    const errors = {};

    if (!inputs.userName?.trim()) {
      errors.userName = 'User Name must not be empty.';
    } else if (!isUserNameValid(inputs.userName)) {
      errors.userName = 'Invalid User Name. Only letters, numbers, and _.+@ are allowed (no spaces).';
    }

    if (!inputs.first_name?.trim()) {
      errors.first_name = 'First Name must not be empty.';
    }

    if (!inputs.last_name?.trim()) {
      errors.last_name = 'Last Name must not be empty.';
    }

    if (!inputs.Password?.trim()) {
      errors.Password = 'Password must not be empty.';
    } else {
      const passwordInvalidMessage = isPasswordValid(inputs.Password);
      if (passwordInvalidMessage) {
        errors.Password = passwordInvalidMessage;
      }
    }

    if (!inputs.userPassword?.trim()) {
      errors.userPassword = 'Confirm Password must not be empty.';
    } else if (inputs.userPassword !== inputs.Password) {
      errors.userPassword = 'Password mismatch.';
    }

    if (!inputs.userEmail?.trim()) {
      errors.userEmail = 'Please give Email id.';
    } else if (!/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(inputs.userEmail.trim())) {
      errors.userEmail = 'Invalid Email Id.';
    }

    if (inputs.is_mfa === '' || inputs.is_mfa == null) {
      errors.is_mfa = 'Please select MFA option.';
    }

    if (inputs.is_location_auth_needed === '' || inputs.is_location_auth_needed == null) {
      errors.is_location_auth_needed = 'Please select Location Authentication option.';
    }

    if (!inputs.uservalid_from) {
      errors.uservalid_from = 'Valid Date (From) is required.';
    }

    if (!inputs.uservalid_upto) {
      errors.uservalid_upto = 'Valid Date (To) is required.';
    }

    if (!selectedCategory || selectedCategory.length === 0) {
      errors.category = 'Please select at least one Category.';
    }

    if (!selectedPlant || selectedPlant.length === 0) {
      errors.plant = 'Please select at least one Plant Location.';
    }

    return errors;
  }

  export function validateUserEditForm(userFormData, selectedCategory, selectedPlant) {
    const errors = {};

    if (!userFormData.username?.trim()) {
      errors.username = 'User Name must not be empty.';
    } else if (!isUserNameValid(userFormData.username)) {
      errors.username = 'Invalid User Name. Only letters, numbers, and _.+@ are allowed (no spaces).';
    }

    if (!userFormData.first_name?.trim()) {
      errors.first_name = 'First Name must not be empty.';
    }

    if (!userFormData.last_name?.trim()) {
      errors.last_name = 'Last Name must not be empty.';
    }

    if (userFormData.newPassword?.trim()) {
      const passwordInvalidMessage = isPasswordValid(userFormData.newPassword);
      if (passwordInvalidMessage) {
        errors.newPassword = passwordInvalidMessage;
      }
      if (!userFormData.userPassword?.trim()) {
        errors.userPassword = 'Confirm Password must not be empty.';
      } else if (userFormData.userPassword.trim() !== userFormData.newPassword.trim()) {
        errors.userPassword = 'Password mismatch.';
      }
    } else if (userFormData.userPassword?.trim()) {
      errors.userPassword = 'Enter the new password above before confirming it.';
    }

    if (!userFormData.email?.trim()) {
      errors.email = 'Please give Email id.';
    } else if (!/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(userFormData.email.trim())) {
      errors.email = 'Invalid Email Id.';
    }

    if (!userFormData.is_superuser) {
      if (!selectedCategory || selectedCategory.length === 0) {
        errors.category = 'Please select at least one Category.';
      }
      if (!selectedPlant || selectedPlant.length === 0) {
        errors.plant = 'Please select at least one Plant Location.';
      }
    }

    return errors;
  }

  export function showUserValidationErrors(errors) {
    const messages = Object.values(errors).filter(Boolean);
    if (messages.length === 0) {
      Swal.fire('Please check * marked fields are filled and details given are valid...', '', 'info');
      return;
    }
    Swal.fire({
      title: 'Please fix the following:',
      html: `<ul style="text-align:left;margin:0;padding-left:1.2rem;">${messages.map((m) => `<li>${m}</li>`).join('')}</ul>`,
      icon: 'info',
    });
  }